module.exports = __webpack_public_path__ + "img/icon_app@2x.bf35e6b7.png";